// @flow
import * as React from 'react';
import {
  DateTime,
} from 'luxon';
import {
  Checkbox,
} from '@atlaskit/checkbox';
import Button from '@atlaskit/button';
import EditorAddIcon from '@atlaskit/icon/glyph/editor/add';
import CameraIcon from '@atlaskit/icon/glyph/camera';

import type {
  DateTime as DT,
} from 'luxon';
import type {
  WorklogGroup,
} from 'chronos-types';

import * as utils from 'chronos-utils';
import {
  StyledComponent,
  CalendarDayHeader,
  CalendarDayHeaderBody,
  CalendarDayHeaderNumber,
  CalendarDayBody,
} from './styled';


type Props = {
  /**
   * CalendarWorklogs to render in component
   */
  children: React.ChildrenArray<React.Node>,
  /**
   * Date of the day
   * */
  date: DT,
  /* Component height
   */
  height?: string,
  /**
   * Whether the day is selected
   */
  selected: boolean,
  /**
   * Whether the day is shadowed
   * */
  shadowed: boolean,
  /**
   * Callback for CalendarDay selection
   * */
  onSelect: { (e: Event): void },
  onAddWorklog: () => void,
  onShowScreenshotsViewer: () => void,
  /**
   * Status of data fetching
   * */
  fetching: boolean,
  worklogGroups: Array<WorklogGroup>,
};

const CalendarDay = ({
  date,
  isScreenshotsExists,
  height,
  selected,
  shadowed,
  children,
  worklogGroups,
  fetching,
  onSelect,
  onAddWorklog,
  onShowScreenshotsViewer,
}: Props): React.Node => (
  <StyledComponent
    height={height}
    selected={selected}
    shadowed={shadowed}
    isToday={DateTime.local().hasSame(date, 'day')}
  >
    <CalendarDayHeader>
      <CalendarDayHeaderBody>
        {!shadowed
        && (
          <>
            <Checkbox
              isChecked={selected}
              value={selected ? 'on' : 'off'}
              label=""
              name="checkbox"
              onChange={onSelect}
            />
            <span>
              {!fetching && utils.stj(
                Object.keys(worklogGroups).reduce(
                  (acc, worklogGroupId) => (
                    acc + worklogGroups[worklogGroupId].timeSpentSeconds
                  ),
                  0,
                ),
              )}
            </span>
          </>
        )}
        {(
          !shadowed
          && isScreenshotsExists
          && !fetching
          && Object.keys(worklogGroups).length !== 0
        ) && (
        <Button
          appearance="subtle-link"
          onClick={() => {
            onShowScreenshotsViewer(
              Object.keys(worklogGroups).reduce(
                (acc, issueId) => ([
                  ...acc,
                  ...worklogGroups[issueId].worklogs.map(w => w.id),
                ]),
                [],
              ),
            );
          }}
          spacing="none"
          style={{
            marginTop: '2px',
            marginLeft: '5px',
          }}
        >
          <CameraIcon size="small" />
        </Button>
        )}
        <CalendarDayHeaderNumber shadowed={shadowed}>
          {date.day}
        </CalendarDayHeaderNumber>
        <Button
          appearance="subtle-link"
          onClick={() => {
            onAddWorklog(date);
          }}
          spacing="none"
        >
          <EditorAddIcon />
        </Button>
      </CalendarDayHeaderBody>
    </CalendarDayHeader>
    <CalendarDayBody
      fetching={fetching}
      shadowed={shadowed}
    >
      {!shadowed && children}
    </CalendarDayBody>
  </StyledComponent>
);

CalendarDay.defaultProps = {
  height: '228px',
};

export default CalendarDay;
